const REPORTING_CHARTS_COLORS = {
    walkin: '#0e8ea6',
    manual: '#8d5c00',
    online: '#0d5785',
    invalid: '#8d2646',
    valid: '#0e8ea6',
};

export { REPORTING_CHARTS_COLORS };

const REPORTING_CHART_CHROME = {
    gridLine: '#e8edf0',
    tickLabel: '#8a959b',
    tickFontSize: 10,
    barRadius: 3,

    categoryGapRatio: 0.5,
};

export { REPORTING_CHART_CHROME };
